import { render, staticRenderFns } from "./TripDriverItem.vue?vue&type=template&id=4952eefa&scoped=true&lang=pug"
import script from "./TripDriverItem.vue?vue&type=script&lang=js"
export * from "./TripDriverItem.vue?vue&type=script&lang=js"
import style0 from "./TripDriverItem.vue?vue&type=style&index=0&id=4952eefa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4952eefa",
  null
  
)

export default component.exports